import React, { useEffect, useState } from "react";
import copys from "../utils/copys";
import ProfileDataItem from "../components/ProfileDataItem";
import { useAuthContext } from "../hooks/useAuthContext";
import { useNavigate, Link } from 'react-router-dom';
import Modal from "../components/modals/Modal";
import ModalLogout from "../components/modals/ModalLogout";
import { genders, localStorageKeyNames } from "../utils/constants";
import * as gtmService from "../services/gtmService";
import Header from "./layout/Header";
import { TermsOrPrivacy } from '../utils/constants';
import { termsAndPrivacy } from '../utils/copys';

const ScreenProfile = () => {
  const { userData, setUserData } = useAuthContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const logout = () => {
    gtmService.pushEvent({
      event: "logout",
      section: "Home",
      user_id: userData.user?.id,
      user_type: 'consumidor',
    })
    setUserData({ isLogged: false, otpRetries: [] });
    localStorage.removeItem(localStorageKeyNames.userRegisterDate);
    localStorage.removeItem(localStorageKeyNames.age);
    localStorage.removeItem(localStorageKeyNames.gender);
    localStorage.setItem(localStorageKeyNames.auth, JSON.stringify({ isLogged: false, otpRetries: [] }));
    navigate("/");
  };

  useEffect(() => {
    window.scrollTo(0, -100);
    if (userData.isLogged === false) {
      navigate("/");
    }
    gtmService.pushPageView('profile');
  }, []);

  const handleLogoutClick = () => {
    gtmService.pushInteractionEvent('interaction_profile', copys.buttonLogout);
    setIsModalOpen(true);
  }

  const handleOkClick = () => {
    gtmService.pushInteractionEvent('interaction_profile', copys.modalLogoutButtonOk);
    logout();
  }

  const handleCancelClick = () => {
    gtmService.pushInteractionEvent('interaction_profile', copys.modalLogoutButtonCancel);
    setIsModalOpen(false);
  }

  return (
    <div className="flex flex-col justify-start h-[80vh]">
      <Header
        customHeader={'Perfil'}
        backButtonCallback={() => navigate(-1)}
      />
      <Modal isOpen={isModalOpen} isCentered>
        <ModalLogout
          onClickOk={handleOkClick}
          onClickCancel={handleCancelClick}
        />
      </Modal>
      <div className="flex flex-col justify-start pb-10">
        <div
          className="flex p-4 text-blue_text font-roboto font-semibold"
          id="profileTitle"
        >
          {copys.titleProfileScreen}
        </div>
        <div className="flex flex-col items-start w-full px-4">
          <ProfileDataItem
            header={copys.profileHeaderName}
            value={userData.user?.name!}
            id="name"
          />
          {userData.user?.birth_year ? (
            <ProfileDataItem
              header={copys.profileHeaderYear}
              value={userData.user?.birth_year}
              id={"birthYear"}
            />
          ) : (
            ""
          )}
          {userData.user?.gender ? (
            <ProfileDataItem
              header={copys.profileHeaderGender}
              value={genders[userData.user?.gender]}
              id={"gender"}
            />
          ) : (
            ""
          )}
        </div>
        <div className="flex justify-center items-center pt-4">
          <button
            id="logoutButton"
            onClick={handleLogoutClick}
            className="flex bg-[#FCCC0A] rounded justify-center items-center py-2 px-4 text-blue_text text-center font-roboto text-base font-semibold"
          >
            {copys.buttonLogout}
          </button>
        </div>
      </div>
      <footer className="flex flex-col items-center gap-[10px] py-6 px-2 shrink-0 fixed bottom-0 w-full text-blue_text font-roboto">
        <div className="underline">
          <Link onClick={() => gtmService.pushInteractionEvent('interaction_footer', termsAndPrivacy.termsFooterLabel)} id="termsLink" to={"/terms/" + TermsOrPrivacy.TERMS}>
            {termsAndPrivacy.termsFooterLabel}
          </Link>
        </div>
        <div className="underline">
          <Link onClick={() => gtmService.pushInteractionEvent('interaction_footer', termsAndPrivacy.privacyFooterLabel)} id="privacyLink" to={"/terms/" + TermsOrPrivacy.PRIVACY}>
            {termsAndPrivacy.privacyFooterLabel}
          </Link>
        </div>
        <div>
          {copys.footerCopyright} Versión {localStorage.getItem(localStorageKeyNames.appVersion)}
        </div>
      </footer>
    </div>
  );
};

export default ScreenProfile;
